import { render, staticRenderFns } from "./ClientMedias.vue?vue&type=template&id=61dc5c4f"
import script from "./ClientMedias.vue?vue&type=script&lang=js"
export * from "./ClientMedias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports